import { Flex, VStack } from "@chakra-ui/react";
import Title from "../Common/Title";
import { Typography } from "@sgi/gravity/Typography";
import { FAIcon } from "@sgi/gravity/FAIcon";
import { faPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import CancelButton from "../Common/Form/CancelButton";
import { useEffect } from "react";

export type PhoneFactorCallMeProps = {
  readonly setSelectedValue: (value: string) => void;
  readonly verificationCodeError: string;
  readonly lastTwoDigits: string;
};

export default function PhoneFactorCallMe({
  setSelectedValue,
  verificationCodeError,
  lastTwoDigits,
}: PhoneFactorCallMeProps) {
  useEffect(() => {
    if (verificationCodeError) {
      setSelectedValue("");
    }
  }, [verificationCodeError, setSelectedValue]);

  return (
    <Flex
      direction="column"
      maxW={544}
      padding={38}
      justifyContent="center"
      mx="auto"
      data-testid="phone-factor-call-me"
    >
      <Title text="Check your phone" />
      <Typography variant="body">
        You should receive a <strong>phone call</strong> soon at
      </Typography>
      <Typography variant="bodyBold">
        +1 (•••) ••• - ••{lastTwoDigits}
      </Typography>
      <VStack>
        <FAIcon icon={faPhone} shake fontSize="4em" m={4} />
      </VStack>
      <CancelButton data-testid="cancel-button-test" />
    </Flex>
  );
}
